import { ACV, ACV_MARGIN, AMOUNT, ARR, ARR_MARGIN, currencyPricePrefix, DISCOUNT, DISCOUNT_PERCENTAGE, LINE_ITEM_CURRENCY_CODE, MARGIN, MRR, MRR_MARGIN, NAME, ORDER, PRE_DISCOUNT_AMOUNT, PRICE, QUANTITY, RECURRING_BILLING_FREQUENCY, SKU, TCV, TCV_MARGIN, TERM, TERM_IN_MONTHS, TOTAL_DISCOUNT, UNIT_COST } from 'customer-data-objects/lineItem/PropertyNames';
import calculateExchangeRatePrice from 'products-ui-components/utils/calculations/calculateExchangeRatePrice';
import { calculateDealAmountByPreference } from 'products-ui-components/utils/calculations/totals';
import { OEM_CALCULATION_PROPERTY_NAMES } from 'products-ui-components/utils/properties/table';
import { DEAL_LINE_ITEM_DEFAULT_ID } from '../constants/associations';
import { typeToId } from '../constants/types';
export const calculateUnitCost = ({
  currencyExchangeRates,
  fromCurrencyCode,
  toCurrencyCode,
  initialPrice
}) => {
  if (!Array.isArray(currencyExchangeRates)) return null;
  if (!initialPrice || typeof initialPrice !== 'string' && typeof initialPrice !== 'number') return null;
  if (fromCurrencyCode === toCurrencyCode) return Number(initialPrice);
  const normalizedCurrencyExchangeRates = currencyExchangeRates.map(item => {
    const mapObj = new Map();
    Object.entries(item).forEach(([key, value]) => {
      mapObj.set(key, value);
    });
    return {
      referencedObject: mapObj
    };
  });
  return calculateExchangeRatePrice(normalizedCurrencyExchangeRates, fromCurrencyCode, toCurrencyCode, Number(initialPrice));
};
export const genarateCalculatePropertiesBody = ({
  lines,
  currency,
  currencyExchangeRates,
  homeCurrency,
  hasMulticurrencyActive
}) => lines.map(({
  quantity,
  product
}) => ({
  objectTypeId: typeToId.lineItem,
  calculatedPropertyNames: OEM_CALCULATION_PROPERTY_NAMES,
  inputPropertyValues: [{
    name: DISCOUNT,
    value: product.properties.discount
  }, {
    name: DISCOUNT_PERCENTAGE,
    value: product.properties.hs_discount_percentage
  }, {
    name: PRICE,
    value: product.properties[hasMulticurrencyActive ? `${currencyPricePrefix}${currency.toLowerCase()}` : 'price']
  }, {
    name: QUANTITY,
    value: quantity.toString()
  }, {
    name: RECURRING_BILLING_FREQUENCY,
    value: product.properties.recurringbillingfrequency
  }, {
    name: TERM,
    value: product.properties.hs_recurring_billing_period
  }, {
    name: UNIT_COST,
    value: calculateUnitCost({
      currencyExchangeRates,
      fromCurrencyCode: homeCurrency,
      toCurrencyCode: currency,
      initialPrice: product.properties.hs_cost_of_goods_sold
    })
  }, {
    name: LINE_ITEM_CURRENCY_CODE,
    value: currency
  }, {
    name: 'hs_tax_rate',
    value: product.properties.hs_tax_rate
  }]
}));
export const productToNewLineItem = ({
  product,
  userId,
  calculations,
  quantity,
  hasMulticurrencyActive,
  currency,
  index,
  appName
}) => {
  const newLineItemProperties = {
    hs_tax_amount: '',
    [ACV]: '',
    hs_lastmodifieddate: product.updatedAt,
    [MARGIN]: '',
    [ARR_MARGIN]: '',
    [LINE_ITEM_CURRENCY_CODE]: currency,
    [PRE_DISCOUNT_AMOUNT]: '',
    hs_object_source: `${appName}-ui`,
    [UNIT_COST]: product.properties.hs_cost_of_goods_sold || '',
    hs_object_id: product.id,
    [PRICE]: (hasMulticurrencyActive ? product.properties[`${currencyPricePrefix}${currency.toLowerCase()}`] : product.properties.price) || '',
    [SKU]: product.properties.hs_sku || '',
    [TCV_MARGIN]: '',
    [QUANTITY]: quantity.toString(),
    [NAME]: product.properties.name || '',
    [ARR]: '',
    [TERM_IN_MONTHS]: '',
    [MRR_MARGIN]: '',
    [TOTAL_DISCOUNT]: '',
    hs_created_by_user_id: userId ? userId.toString() : '',
    [TCV]: '',
    hs_object_source_id: `userId:${userId || ''}`,
    hs_post_tax_amount: '',
    [ACV_MARGIN]: '',
    hs_object_source_user_id: userId ? userId.toString() : '',
    [AMOUNT]: '',
    [MRR]: '',
    [ORDER]: index.toString(),
    hs_product_type: product.properties.hs_product_type || '',
    hs_product_id: product.id,
    hs_updated_by_user_id: userId ? userId.toString() : ''
  };
  calculations.calculationOutputs.forEach(({
    name,
    value
  }) => {
    if (newLineItemProperties[name] !== undefined) {
      newLineItemProperties[name] = value;
    }
  });
  return newLineItemProperties;
};
export const calculateDealAmount = ({
  lineItems,
  dealAmountPreference,
  currency,
  userId,
  appName
}) => {
  const convertedLineItems = lineItems.map(lineItem => {
    const newProperties = {};
    Object.entries(lineItem).forEach(([key, value]) => {
      newProperties[key] = {
        name: key,
        value,
        source: `${appName}-ui`,
        sourceId: `${appName}-ui`,
        timestamp: Date.now(),
        updatedByUserId: userId
      };
    });
    return {
      properties: newProperties,
      objectId: DEAL_LINE_ITEM_DEFAULT_ID,
      isNew: true
    };
  });
  return calculateDealAmountByPreference(convertedLineItems, dealAmountPreference, currency);
};
export const generateCreateLineItemsBatchBody = ({
  newLineItems,
  toObjectId,
  associationTypeId
}) => {
  return newLineItems.map(lineItem => ({
    properties: lineItem,
    associations: [{
      to: {
        id: toObjectId
      },
      types: [{
        associationCategory: 'HUBSPOT_DEFINED',
        associationTypeId
      }]
    }]
  }));
};